module.exports = __webpack_public_path__ + "static/media/16UNODC16.2f4a1ec3.jpg";